module.exports = __webpack_public_path__ + "3a1b440abe85284006a4f5706e9a5f78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-03.png
// module id = 471
// module chunks = 0